import { createElement, useState, useEffect } from "react";
import { string, func, node } from "prop-types"

const Capem = ({
  el = "div",
  personId = "new",
  onSave = () => {},
  firstName,
  lastName,
  children,
  ...rest
}) => {
  const [url, setUrl] = useState(null)

  useEffect(() => {
    let href = "/person_editor/people/" + personId + "?"
    if (firstName) {
      href += `&person[first_name]=${firstName}`
    }
    if (lastName) {
      href += `&person[last_name]=${lastName}`
    }
    setUrl(href)
  }, [personId, firstName, lastName])

  const handleClick = event => {
    event.preventDefault()
    $("body").addClass("capem--open")
    PersonEditorModal.afterClose = data => {
      onSave(data)
      $("body").removeClass("capem--open")
    }
    PersonEditorModal.load(url)
  }

  return createElement(
    el,
    {
      className: "w-100% create-btn btn2",
      onClick: handleClick,
      ...rest
    },
    children
  );
}

Capem.propTypes = {
  el: string,
  personId: string,
  firstName: string,
  lastName: string,
  onSave: func,
  children: node
}

export default Capem
